import {
  FK, Field, Row, Section, TextArea, Select, SuffixInput, FkToggle,
} from "../product_config/formkit";

export default function ConfiguracionFinancieraTab({ formData, handleChange, handleSelectChange }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
        <Row>
          <Field label="UF base" htmlFor="uf_base">
            <SuffixInput id="uf_base" name="uf_base" type="number" value={formData.uf_base} onChange={handleChange} placeholder="0,00" suffix="UF" />
          </Field>
          <Field label="Capital UF" htmlFor="capital_uf">
            <SuffixInput id="capital_uf" name="capital_uf" type="number" value={formData.capital_uf} onChange={handleChange} placeholder="0,00" suffix="UF" />
          </Field>
        </Row>
        <Row>
          <Field label="Previsión" htmlFor="prevision">
            <Select
              id="prevision"
              value={formData.prevision || ""}
              placeholder="Selecciona previsión"
              options={[{ value: "ISAPRE", label: "ISAPRE" }, { value: "FONASA", label: "FONASA" }]}
              onChange={(e) => handleSelectChange('prevision', e.target.value)}
            />
          </Field>
          <Field label="Moneda" htmlFor="moneda">
            <Select
              id="moneda"
              value={formData.moneda || "UF"}
              options={[{ value: "UF", label: "UF" }, { value: "CLP", label: "CLP" }]}
              onChange={(e) => handleSelectChange('moneda', e.target.value)}
            />
          </Field>
        </Row>
        <Row>
          <Field label="Estado del plan" htmlFor="activo-fin">
            <div style={{ display: "flex", alignItems: "center", gap: 10, height: 40 }}>
              <FkToggle on={formData.activo} onChange={(v) => handleSelectChange('activo', v)} />
              <span style={{ fontSize: 13.5, color: FK.sub }}>{formData.activo ? "Plan activo" : "Plan inactivo"}</span>
            </div>
          </Field>
        </Row>
      </div>

      <Section title="Medios de pago" desc="Formas de cobro que este plan acepta.">
        <Row>
          <Field label="Suscripción" htmlFor="subscription-fin">
            <div style={{ display: "flex", alignItems: "center", gap: 10, height: 40 }}>
              <FkToggle on={formData.subscription} onChange={(v) => handleSelectChange('subscription', v)} />
              <span style={{ fontSize: 13.5, color: FK.sub }}>{formData.subscription ? "Admite pago por suscripción" : "No admite pago por suscripción"}</span>
            </div>
          </Field>
          <Field label="Contado" htmlFor="contado-fin">
            <div style={{ display: "flex", alignItems: "center", gap: 10, height: 40 }}>
              <FkToggle on={formData.contado} onChange={(v) => handleSelectChange('contado', v)} />
              <span style={{ fontSize: 13.5, color: FK.sub }}>{formData.contado ? "Admite pago al contado" : "No admite pago al contado"}</span>
            </div>
          </Field>
        </Row>
      </Section>

      <Section title="Cobertura y deducible" desc="Texto descriptivo que se muestra en la ficha del plan.">
        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <Field label="Cobertura" htmlFor="cobertura" full>
            <TextArea id="cobertura" name="cobertura" value={formData.cobertura} onChange={handleChange} rows={3} placeholder="Descripción de la cobertura" />
          </Field>
          <Field label="Reglas de deducible" htmlFor="reglas_deducible" full>
            <TextArea id="reglas_deducible" name="reglas_deducible" value={formData.reglas_deducible} onChange={handleChange} rows={3} placeholder="Reglas del deducible" />
          </Field>
        </div>
      </Section>
    </div>
  );
}
